import { bindActionCreators } from 'redux';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Router from 'next/router';
import getConfig from 'next/config';

import * as f from 'lib/common/features';
import {
  getSessionError,
  getSessionFeatures,
} from 'lib/store/session/selectors';
import { login } from 'lib/store/session/actions';
import withTracking from 'lib/hocs/withTracking';
// eslint-disable-next-line no-restricted-imports
import config from '../../../config';
import signupRedirectCheck from '../signup/lib/signupRedirectCheck';
import LoginPage from './LoginPage';

const {
  publicRuntimeConfig: { brazeApiKey },
} = getConfig();

/**
 * A 'smart' 'container' component, aware of Redux and Next.
 * It's job is to pass the correct props to it's dumb
 * presentational child.
 */
class LoginPageContainer extends Component {
  static getInitialProps({ query }) {
    return { redirect: query.redirect };
  }

  static propTypes = {
    redirect: PropTypes.string,
    userId: PropTypes.string,
    isSso: PropTypes.bool,
    tracker: withTracking.TYPE.isRequired,
    hasPushNotificationsEnabled: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    redirect: config.landingPage,
    userId: null,
    isSso: null,
  };

  registerUserWithBraze = async () => {
    const { userId, hasPushNotificationsEnabled } = this.props;
    if (!hasPushNotificationsEnabled) return;
    const appboy = await import('appboy-web-sdk');
    await appboy.initialize(brazeApiKey, {
      baseUrl: 'sdk.fra-01.braze.eu',
      manageServiceWorkerExternally: true,
    });
    await appboy.changeUser(userId);
    appboy.openSession();
  };

  onLoginSuccess = (result) => {
    const { redirect, userId } = this.props;
    global.analytics.identify(userId);

    if (!signupRedirectCheck(result)) {
      Router.push(redirect);
    }

    this.registerUserWithBraze();
  };

  render() {
    return <LoginPage {...this.props} onLoginSuccess={this.onLoginSuccess} />;
  }
}

export default connect(
  (state) => {
    const features = getSessionFeatures(state);

    return {
      countryCode: state.request.countryCode,
      error: getSessionError(state),
      hasPushNotificationsEnabled: features.has(
        f.RS_HOME_ENABLE_PUSH_NOTIFICATIONS,
      ),
    };
  },
  (dispatch) => ({
    actions: bindActionCreators({ login }, dispatch),
  }),
)(withTracking(LoginPageContainer));

// unwrapped  export for testing
export { LoginPageContainer };
